var symphony = symphony || {};

;
(function () {

  symphony.donateHeaderActions = function () {

    $('.js-donateHeader').on('click', function (e) {
      e.preventDefault();
      performDonateHeaderToggle(this);
    });
    $('.js-donateHeader').on('keypress', function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        performDonateHeaderToggle(this);
      }
    });

    function performDonateHeaderToggle(elm) {
      // On certain pages, check to make sure that .expandingHeader has been initialized correctly.
      if (!disableDonationDropDown && (symphony.config.utilities.expandingHeader == null || symphony.config.utilities.expandingHeader.length == 0)) {
        symphony.config.utilities.expandingHeader = $(".js-doesExpand");
      }

      if (!disableDonationDropDown && symphony.config.utilities.expandingHeader.hasClass('isExpanded')) {
        $(elm).removeClass('donateHeader-expanded');
        symphony.config.utilities.expandingHeader.removeClass('isExpanded');
      } else {
        if (disableDonationDropDown) {
          var donateUrl = $('a.js-donateHeader').attr('href');
          if (typeof utag != "undefined") {
            utag.view({
              'event_name': 'Donate', //Event Name
              'link_text': 'Donate', //Link Text
              'site_section': 'Homepage', //Site Section
              'site_type': 'SAL:' + utagSite, //Site Type
              'login_status': 'Not Logged In', //Login Status
              'event_type': 'donate_header', //Event Type
            }, function () {
              setTimeout(function () {
                window.open(donateUrl);
              }, 600);
            });
          } else {
            window.open(donateUrl);
          }
        } else {
          $('.donateHeader').addClass('isExpanded');
          $(elm).addClass('donateHeader-expanded');

          if (typeof utag != "undefined") {
            utag.view({
              'event_name': 'Donate', //Event Name
              'link_text': 'Donate', //Link Text
              'site_section': 'Homepage', //Site Section
              'site_type': 'SAL:' + utagSite, //Site Type
              'login_status': 'Not Logged In', //Login Status
              'event_type': 'donate_header', //Event Type
            });
          }
        }
      }
    }

    $('.donateHeader-amounts').find('a').on('click', function (e) {
      e.preventDefault();
      $('.donateHeader-amounts').find('a').removeClass('isSelected');
      $(this).addClass('isSelected');
    });

    $('.donateHeader-submit').find('a').on('click', function (e) {
      e.preventDefault();
      performDonateSubmit();
    });
    $('.donateHeader-submit').find('a').on('keypress', function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        performDonateSubmit();
      }
    });

    function performDonateSubmit() {
      var donateUrl = $('.donateHeader-amounts').find('a.isSelected').attr('href');
      if (_.isUndefined(donateUrl)) {
        donateUrl = $('.donateHeader-amounts a:last-child').attr('href');
      }
      if (_.isUndefined(donateUrl) || disableDonationPassthru) {
        donateUrl = $('a.js-donateHeader').attr('href');
      }
      if (typeof utag != 'undefined') {
        var amt = UTIL.GetQueryStringParameterByName('amt', donateUrl);
        if (typeof amt == "undefined" || amt == undefined || amt == null || amt == "" || amt == "Other") {
          amt = '';
        }

        utag.link({
          'event_name': 'Donate', //Event Name
          'link_text': 'Donate', //Link Text
          'site_section': 'Homepage', //Site Section
          'site_type': 'SAL:' + utagSite, //Site Typelts
          'login_status': 'Not Logged In', //Login Status ID
          'event_type': 'donate', //Event Typee
          'donation_amount': amt, //Donation Amount
          'button_location': 'donate_header' // Location or section of the Donate button on the page
        }, function () {
          setTimeout(function () {
            window.open(donateUrl);
          }, 600);
        });
      } else {
        window.open(donateUrl);
      }
    }

  };

})();
